import * as gamMethods from '../../consts/gam/gamMethods';
import {makeSelectIotDeviceMergedWithConsumerProduct} from '../../state/selectors/consumer';
import {getState} from '../../state/store';
import authDataStoreService from '../auth/authDataStoreService';
import {getGigyaToken} from '../gigya/gigyaService';
import iccTelemetryService from '../icc/iccTelemetryService';
import GamClient from './gamClient';

const getCodentify = (isHolder) => {
    const iotDevice = makeSelectIotDeviceMergedWithConsumerProduct()(getState());

    if (isHolder) {
        return iotDevice?.holder?.codentifyOriginal;
    }

    const deviceCodentify = iotDevice?.device?.codentifyOriginal;

    if (deviceCodentify) return deviceCodentify;

    throw new Error('Device codentify is not exist');
};

export const fetchGamToken = async (isHolder) => {
    const gigyaJWT = getGigyaToken();

    if (!gigyaJWT) throw new Error('gamGigyaService: GigyaToken does not exist in local storage');

    const codentify = getCodentify(isHolder);
    const requestConfig = {
        headers: {Authorization: 'Bearer ' + gigyaJWT},
        args: codentify,
    };
    const response = await new GamClient().callPut({
        methodName: gamMethods.MANAGE_DEVICE,
        requestConfig,
        isNeedRedirectForOtherErrors: false,
        isHolder,
    });

    if (!response) return false;
    if (response !== true) {
        const authToken = response.authtoken;

        authDataStoreService.setGamApiData(isHolder, authToken);

        // Track only for charger
        if (!isHolder) {
            iccTelemetryService.trackStartConnectEvent(codentify);
        }
    }

    return true;
};
